import type { Child, ChildCategory } from "@/types";
import { getPatientImageUrl, getFondIconUrl, getClinicIconUrl } from "@/api";

/** typeHelpName -> ChildCategory */
export function getCategoryFromTypeHelp(typeHelpName: string): ChildCategory {
  const u = (typeHelpName ?? "").toLowerCase();
  if (u.includes("jarrohlik") || u.includes("operatsiya") || u.includes("хирург") || u.includes("surgical")) return "operatsiya";
  if (u.includes("davolash") || u.includes("лечен") || u.includes("treatment")) return "davolash";
  if (u.includes("dori") || u.includes("препарат") || u.includes("medicine")) return "dori";
  if (u.includes("reabilitatsiya") || u.includes("реабилитац") || u.includes("rehabilit")) return "reabilitatsiya";
  return "operatsiya";
}

/** UI da ko'rsatish uchun formatlanган maydonlar */
export interface ChildDisplay {
  name: string;
  age: number;
  diagnosis: string;
  goal: number;
  collected: number;
  location: string;
  image: string;
  story: string;
  urgent: boolean;
  category: ChildCategory;
  fondName: string;
  fondIcon: string;
  clinicName: string;
  clinicIcon: string;
  statusId?: number;
}

/**
 * Child → ChildDisplay.
 * Matn maydonlari API dan til-neytral keladi (Lang header orqali),
 * shuning uchun locale parametri kerak emas.
 */
export function getChildDisplay(child: Child): ChildDisplay {
  return {
    name: `${child.firstName ?? ""} ${child.lastName ?? ""}`.trim() || "—",
    age: child.patientAge ?? 0,
    diagnosis: child.sickCategoryName ?? "",
    goal: child.amount ?? 0,
    collected: child.collected ?? 0,
    location: child.patientRegion ?? "",
    image: getPatientImageUrl(child.patientPhotoId),
    story: child.description ?? "",
    urgent: child.typeNeedId === 1,
    category: getCategoryFromTypeHelp(child.typeHelpName),
    fondName: child.fondName ?? "",
    fondIcon: getFondIconUrl(child.fondIcon),
    clinicName: child.clinicName ?? "",
    clinicIcon: getClinicIconUrl(child.clinicIcon),
  };
}
